import { render, staticRenderFns } from "./DetalleClaseCero.vue?vue&type=template&id=54bfcd05&"
import script from "./DetalleClaseCero.vue?vue&type=script&lang=js&"
export * from "./DetalleClaseCero.vue?vue&type=script&lang=js&"
import style0 from "./DetalleClaseCero.vue?vue&type=style&index=0&id=54bfcd05&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports